import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { CustomerJourney } from '@/pages/record-and-send-public/link/customer-journey';
import { LinkFramedPage } from '@/pages/record-and-send-public/link/link-status-page';
import { isInIframe } from '@/stores/global.store';

// The invite sets the language, so a ?lang in the address is dropped.
export const Route = createFileRoute('/v/$secret')({
	validateSearch: z.object({}),
	beforeLoad: ({ search, params }) => {
		if (search.lang) throw redirect({ to: '/v/$secret', params, search: {}, replace: true });
	},
	component: CustomerLinkRoute,
});

function CustomerLinkRoute() {
	const { secret } = Route.useParams();
	if (isInIframe()) return <LinkFramedPage href={window.location.href} />;
	return <CustomerJourney secret={secret} />;
}
